import { translate } from "app/filters/i18nFilter";
import withTooltipCell from "app/pages/sales-intelligence/pages/home/hoc/withTooltipCell";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import type { FlexTableColumnType } from "app/pages/sales-intelligence/types";

import AssetsCountCell from "../../../components/cells/AssetsCountCell/AssetsCountCell";
import { HeaderCellRightAlign } from "../../../components/cells/HeaderCell/HeaderCellRightAlign";
import ResultAssetCell from "../../../components/cells/ResultAssetCell/ResultAssetCell";
import createTableColumn from "../base/baseColumnFactory";
import { ACCOUNTS_WITH_SIGNALS_COLUMN } from "../columnNames";

import { NEW_ACCOUNTS_COLUMN, SAVED_SEARCHES_NAME_COLUMN } from "./columnNames";
import type { SavedSearchesCellProps } from "./types";
import { createSavedSearchesCell } from "./utils";

const fieldToCellMap = {
    [SAVED_SEARCHES_NAME_COLUMN]: createSavedSearchesCell(ResultAssetCell),

    [NEW_ACCOUNTS_COLUMN]: createSavedSearchesCell(({ ...cellProps }: SavedSearchesCellProps) => {
        const value = cellProps.value ?? cellProps.row.newAccountsCount;

        const handleOnClick = () => {
            siNavigator.goToSavedSearchPageById({
                savedSearchId: cellProps.row.searchId,
                isNewOnly: true,
            });
        };

        return (
            <AssetsCountCell
                {...cellProps}
                onClick={handleOnClick}
                value={value}
            />
        );
    }),

    [ACCOUNTS_WITH_SIGNALS_COLUMN]: createSavedSearchesCell(({ ...cellProps }: SavedSearchesCellProps) => {
        const value = cellProps.value ?? cellProps.row.accountsWithSignalsCount;

        return (
            <AssetsCountCell
                {...cellProps}
                value={value}
            />
        );
    }),
};

export const savedSearchesColumns: FlexTableColumnType[] = [
    createTableColumn({
        field: SAVED_SEARCHES_NAME_COLUMN,
        cellComponent: fieldToCellMap[SAVED_SEARCHES_NAME_COLUMN],
    }),

    createTableColumn({
        field: NEW_ACCOUNTS_COLUMN,
        headerComponent: withTooltipCell({
            get tooltipText() {
                return translate("si.pages.home.card.columns.tooltip.new-results.company");
            },
        })(HeaderCellRightAlign),
        cellComponent: fieldToCellMap[NEW_ACCOUNTS_COLUMN],
    }),

    createTableColumn({
        field: ACCOUNTS_WITH_SIGNALS_COLUMN,
        headerComponent: withTooltipCell({
            get tooltipText() {
                return translate("si.pages.home.card.columns.tooltip.accounts-with-signals");
            },
        })(HeaderCellRightAlign),
        cellComponent: fieldToCellMap[ACCOUNTS_WITH_SIGNALS_COLUMN],
    }),
];
